import { SearchQuery } from '@numeo/types-core'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MovementStatusCounts, TruckStatusCounts, UpdaterMapTruck } from 'pages/dashboard/pages/updater-agent/pages/dashboard/types'
import { RootState } from 'store'

interface DashboarState {
    updatedTrucks: UpdaterMapTruck[]
    selectedTruck: UpdaterMapTruck | null
    hoveredTruck: UpdaterMapTruck | null
    showInfoWindow: boolean
    isLoading: boolean
    statusCounts: TruckStatusCounts
    movementStatusCounts: MovementStatusCounts
    shouldRefetchTrucks: boolean
    searchQuery: SearchQuery
    isMapDark: boolean
    selectedSchedulerTruck: string | null
    selectedCompanyIds: string[]
    filteredTrucks: UpdaterMapTruck[]
}

const initialState: DashboarState = {
    updatedTrucks: [],
    selectedTruck: null,
    hoveredTruck: null,
    showInfoWindow: false,
    isLoading: false,
    statusCounts: {
        late: 0,
        onSchedule: 0,
        unassigned: 0,
        total: 0,
    },
    shouldRefetchTrucks: false,
    searchQuery: {
        query: '',
        statusFilter: 'all',
        etaFilter: 'all',
        isLoadAssignedFilter: 'all',
        dispatcherFilter: ['all'],
    },
    movementStatusCounts: {
        moving: 0,
        idle: 0,
        stopped: 0,
        unknown: 0,
    },
    isMapDark: false,
    selectedSchedulerTruck: null,
    selectedCompanyIds: [],
    filteredTrucks: [],
}

const dashboardSlice = createSlice({
    name: 'driver',
    initialState,
    reducers: {
        setUpdatedTrucks(state, action: PayloadAction<UpdaterMapTruck[]>) {
            state.updatedTrucks = action.payload
        },
        setSelectedTruck(state, action: PayloadAction<UpdaterMapTruck | null>) {
            state.selectedTruck = action.payload
        },
        setIsLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload
        },
        setStatusCounts(state, action: PayloadAction<TruckStatusCounts>) {
            state.statusCounts = action.payload
        },
        setShouldRefetchTrucks(state, action: PayloadAction<boolean>) {
            state.shouldRefetchTrucks = action.payload
        },
        setSearchQuery(state, action: PayloadAction<SearchQuery>) {
            state.searchQuery = action.payload
        },
        setMovementStatusCounts(state, action: PayloadAction<MovementStatusCounts>) {
            state.movementStatusCounts = action.payload
        },
        setHoveredTruck(state, action: PayloadAction<UpdaterMapTruck | null>) {
            state.hoveredTruck = action.payload
        },
        setShowInfoWindow(state, action: PayloadAction<boolean>) {
            state.showInfoWindow = action.payload
        },
        setIsMapDark(state, action: PayloadAction<boolean>) {
            state.isMapDark = action.payload
        },
        setSelectedSchedulerTruck(state, action: PayloadAction<string | null>) {
            state.selectedSchedulerTruck = action.payload
        },
        setSelectedCompanyIds(state, action: PayloadAction<string[]>) {
            state.selectedCompanyIds = action.payload
        },
        setFilteredTrucks(state, action: PayloadAction<UpdaterMapTruck[]>) {
            state.filteredTrucks = action.payload
        },
    },
})

export const {
    setSelectedTruck,
    setUpdatedTrucks,
    setIsLoading,
    setStatusCounts,
    setMovementStatusCounts,
    setShouldRefetchTrucks,
    setSearchQuery,
    setHoveredTruck,
    setShowInfoWindow,
    setIsMapDark,
    setSelectedSchedulerTruck,
    setSelectedCompanyIds,
    setFilteredTrucks,
} = dashboardSlice.actions

export const selectUpdatedTrucks = (state: RootState) => state.dashboard.updatedTrucks
export const selectSelectedTruck = (state: RootState) => state.dashboard.selectedTruck
export const selectIsLoading = (state: RootState) => state.dashboard.isLoading
export const selectHoveredTruck = (state: RootState) => state.dashboard.hoveredTruck
export const selectStatusCounts = (state: RootState) => state.dashboard.statusCounts
export const selectShouldRefetchTrucks = (state: RootState) => state.dashboard.shouldRefetchTrucks
export const selectSearchQuery = (state: RootState) => state.dashboard.searchQuery
export const selectMovementStatusCounts = (state: RootState) => state.dashboard.movementStatusCounts
export const selectShowInfoWindow = (state: RootState) => state.dashboard.showInfoWindow
export const selectIsMapDark = (state: RootState) => state.dashboard.isMapDark
export const selectSelectedSchedulerTruck = (state: RootState) => state.dashboard.selectedSchedulerTruck
export const selectSelectedCompanyIds = (state: RootState) => state.dashboard.selectedCompanyIds
export const selectFilteredTrucks = (state: RootState) => state.dashboard.filteredTrucks
//
//
export type { DashboarState }
export default dashboardSlice.reducer
